// extracted by mini-css-extract-plugin
export default {"audioVisualizer":"AudioVisualizer_audioVisualizer__wDQZv","visualizerCanvas":"AudioVisualizer_visualizerCanvas__uIV0j","errorMessage":"AudioVisualizer_errorMessage__a-cuS"};